import React from "react";
import T from "prop-types";
import { Map } from "immutable";
import { Attachments, Notes } from "MODULES/shared/components";
import resourceTypes from "MODULES/shared/types/resourceTypes";
import { ATTACHMENT_TYPES } from "MODULES/RMAsAndWarranties/constants";

export default function Body({ rma }) {
  const attachmentTypes =
    rma.type === "CustomerRma"
      ? ATTACHMENT_TYPES.customer
      : ATTACHMENT_TYPES.vendor;
  return (
    <div className="col-md-9">
      <Notes resource={Map(rma)} resourceType={resourceTypes.rma} />
      <Attachments
        attachmentTypes={attachmentTypes}
        multiple
        resource={Map(rma)}
        resourceType={resourceTypes.rma}
        resourceKey="rma"
      />
    </div>
  );
}

Body.propTypes = { rma: T.shape({}).isRequired };



// WEBPACK FOOTER //
// ./app/modules/RMAsAndWarranties/components/Detail/Body/Body.jsx